import type { Configuration, RedirectRequest } from '@azure/msal-browser';

function getRequiredEnv(key: string): string {
  const value = import.meta.env[key] as string | undefined;
  if (!value) {
    throw new Error(`Missing required MSAL environment variable: ${key}`);
  }
  return value;
}

const clientId = getRequiredEnv('VITE_MSAL_CLIENT_ID');
const tenantId = getRequiredEnv('VITE_MSAL_TENANT_ID');

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest: RedirectRequest = {
  scopes: ['User.Read', 'User.ReadBasic.All'],
};

export const apiTokenRequest: RedirectRequest = {
  scopes: [`${clientId}/.default`],
};

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  graphPhotoEndpoint: 'https://graph.microsoft.com/v1.0/me/photo/$value',
} as const;
